import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=b46e4b2e&scoped=true"
import script from "./StudyCourse.vue?vue&type=script&lang=js"
export * from "./StudyCourse.vue?vue&type=script&lang=js"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=b46e4b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46e4b2e",
  null
  
)

export default component.exports